import FieldBadgeProps from './FieldBadgeProps';
import Badge from '../../mui-builder/Badge/Badge';

const CustomBadge = (props: FieldBadgeProps) => {
  const { text, sx, ...otherProps } = props;

  return (
    <Badge color="primary" sx={{ ml: 1, '&:first-child': { ml: 0 }, ...sx }} {...otherProps}>
      {text}
    </Badge>
  );
};

export default CustomBadge;
